<template>
    <div id="lightBG" class="lightBG aboutUsBg" :style="'background-image:url(' + aboutUs + ')'">
        <div class="title">
            关于我们
        </div>
        <div class="title">
            ABOUT US
        </div>
        <div id="pageCard" class="pageCard contentBox mainContent">
            <div class="pageCardTitle">
                <div id="type1" class="pageCardTitleText" @click="getBaseData(1)">
                    公司介绍
                </div>
                <div id="type2" class="pageCardTitleText" @click="getBaseData(2)">
                    公司荣誉
                </div>
                <div id="type3" class="pageCardTitleText" @click="getBaseData(3)">
                    联系我们
                </div>
                <div id="type4" class="pageCardTitleText" @click="getBaseData(4)">
                    人才招聘
                </div>
            </div>
            <BannerIMG v-if="type == 1" :bannerArray="banners" />
            <div v-if="type == 1" class="pageCardContet">
                <div v-for="info in companyList" :key="info.id">
                    <div class="title">
                        <div>{{info.title}}</div>
                        <div>{{info.en_title}}</div>
                    </div>
                    <div class="content">
                        <div class="verticalLine" v-if="info.type == 1"></div>
                        <div v-if="info.type == 1" class="text" v-html="info.content"></div>
                        <div v-if="info.type == 2" class="img">
                            <img v-for="img in imgList" :key="img" :src="img" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="type == 2" class="pageCardContetType2">
                <div class="item" v-for="item in honerList" :key="item.id">
                    <div class="img">
                        <img :src="baseUrl+item.image" />
                        <div class="text">
                            <div><i class="el-icon-trophy titleIcon"></i>{{ item.title }}</div>
                            <div class="content">
                                <div class="verticalLine"></div>
                                <div class="type2Text" v-html="item.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="type == 3" class="pageCardContetType3">
                <div class="map-container" @wheel="handleMapWheel">
                    <img :src="mapImage" class="map-image" :style="{transform: `scale(${mapScale})`}" />
                </div>
                <div class="card">
                    <div class="item">
                        <div class="icon">
                            <img :src="i1" />
                        </div>
                        <div>
                            郭经理:15101614752<br>
                            刘经理:15837840771
                        </div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <img :src="i2" />
                        </div>
                        <div>
                            <a href="mailto:feitem316@163.com">feitem316@163.com</a>
                        </div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <img :src="i3" />
                        </div>
                        <div>
                            河南省开封市龙亭区郑开大道与八大街交界三合国际4楼
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="type == 4" class="pageCardContetType4">
                <div class="listBox">
                    <div class="info" v-for="item in joinUsList" :key="item.id" @click="expandInfo(item.id)">
                        <div class="row">
                            <i class="line"></i>
                            <div class="title">
                                <h3>{{ item.title }}</h3>
                            </div>
                            <div class="date">
                                {{ item.date }} 更新 <i class="el-icon-caret-bottom icon" :ref="'icon'+item.id"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="content" :ref="'content'+item.id" v-html="item.content">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="mob">
            <div class="title">
                <div class="zh">
                    关于我们
                </div>
                <div class="en">
                    About Us
                </div>
            </div>
            <div class="card" id="companyIntro">
                <div class="item" v-for="info in companyList" :key="info.id">
                    <div class="title">
                        <div>{{info.title}}</div>
                        <div>{{info.en_title}}</div>
                    </div>
                    <div class="content">
                        <div v-if="info.type == 1" class="text" v-html="info.content"></div>
                        <div v-if="info.type == 2" class="img">
                            <div class="list" v-for="img in imgList" :key="img">
                                <el-image :src="img" :preview-src-list="imgList">
                                </el-image>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" id="companyHornor">
                <div class="item" v-for="item in honerList" :key="item.id">
                    <div class="title">{{ item.title }}</div>
                    <div class="img">
                        <img :src="baseUrl+item.image" />
                        <div class="text">
                            <div class="content">
                                <div class="type2Text" v-html="item.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" id="map">
                <div class="item">
                    <div class="title">联系我们</div>
                    <div class="map-container" @wheel="handleMapWheel">
                        <img :src="mapImage" class="map-image" :style="{transform: `scale(${mapScale})`}" />
                    </div>
                </div>
                <div class="item text">
                    <div class="icon">
                        <img :src="i1" />
                    </div>
                    <div>
                        <a href="tel:15101614752">郭经理:15101614752</a><br>
                        <a href="tel:15837840771">刘经理:15837840771</a>
                    </div>
                </div>
                <div class="item text">
                    <div class="icon">
                        <img :src="i2" />
                    </div>
                    <div>
                        <a href="mailto:feitem316@163.com">feitem316@163.com</a>
                    </div>
                </div>
                <div class="item text">
                    <div class="icon position">
                        <img :src="i3" />
                    </div>
                    <div>
                        河南省开封市龙亭区郑开大道与八大街交界三合国际4楼
                    </div>
                </div>
            </div>

            <div class="card" id="joinUs">
                <div class="item">
                    <div class="title">诚聘英才</div>
                </div>
                <div class="item">
                    <div class="listBox">
                        <div class="info" v-for="item in joinUsList" :key="item.id" @click="expandInfo(item.id)">
                            <div class="row">
                                <div class="title">
                                    <h3>{{ item.title }}<i class="el-icon-caret-bottom icon" :ref="'icon'+item.id"></i>
                                    </h3>
                                </div>
                                <div class="date">
                                    {{ item.date }} 更新
                                </div>
                            </div>
                            <div class="row">
                                <div class="content" :ref="'content'+item.id" v-html="item.content">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BannerIMG from '@/components/BannerIMG.vue';
    //静态资源导入
    import aboutUs from '@/assets/img/aboutUs.jpg';
    import i1 from '@/assets/img/i1.png';
    import i2 from '@/assets/img/i2.png';
    import i3 from '@/assets/img/i3.png';
    import mapImage from 'd:/guanwang/image.png';

    export default {
        name: 'aboutUsPage',
        components: {
            BannerIMG
        },
        watch: {
            // '$route.query.type':function(type){
            //     console.log(type);
            //     this.type = type;
            // },
            '$route.query.type': function (newType) {
                this.type = newType; // 更新 type
                this.getBaseData(newType)
            },
            'isBaseDataOK': function () {
                if (this.isIMGOK && this.isBaseDataOK) {
                    this.$root.loadingClose();
                }
            },
            'isIMGOK': function () {
                if (this.isIMGOK && this.isBaseDataOK) {
                    this.$root.loadingClose();
                }
            },
            'type': function () {
                this.isIMGOK = false;
                this.isBaseDataOK = false;
                this.$nextTick(() => {
                    this.fixLightBGHeight("pageCard", "lightBG");
                });
                if (this.type == 2) {
                    this.$nextTick(() => {
                        this.turnItems();
                    })
                }
            },
            'companyList': function () {
                this.$nextTick(() => {
                    this.fixLightBGHeight("pageCard", "lightBG");
                })
            },
            'imgList': function () {
                this.$nextTick(() => {
                    this.fixLightBGHeight("pageCard", "lightBG");
                })
            },
            'honerList': function () {
                this.$nextTick(() => {
                    this.fixLightBGHeight("pageCard", "lightBG");
                    this.turnItems();
                })
            },
            'joinUsList': function () {
                this.$nextTick(() => {
                    this.fixLightBGHeight("pageCard", "lightBG");
                    this.turnItems();
                })
            }
        },
        data() {
            return {
                //静态资源声明S
                aboutUs: aboutUs,
                i1: i1,
                i2: i2,
                i3: i3,
                //静态资源声明E

                //地图图片缩放数据S
                mapScale: 1,
                mapImage: mapImage,
                //地图图片缩放数据E
                banners: [],
                baseUrl: window.config.apiUrl,
                isBaseDataOK: false,
                isIMGOK: false,
                type: 1,
                companyList: [],
                imgList: [],
                honerList: [],
                joinUsList: [],
                expandList: [],
                srcList: [],
            }
        },
        methods: {
            handleMapWheel(event) {
                event.preventDefault();
                const scaleStep = 0.1;
                if (event.deltaY < 0) {
                    this.mapScale = Math.min(this.mapScale + scaleStep, 3);
                } else {
                    this.mapScale = Math.max(this.mapScale - scaleStep, 0.5);
                }
            },
            async getBaseData(type = null) {
                if (null == type) {
                    // 获取地址栏参数
                    let url = window.location.href;
                    let params = url.split('?')[1];
                    let paramsArray = {};

                    if (params) {
                        params = params.split('&');

                        params.forEach(param => {
                            let item = param.split('=');
                            paramsArray[item[0]] = item[1];
                        });
                    }
                    if (paramsArray["type"] != undefined) {
                        type = paramsArray["type"];
                    }
                    else {
                        type = 1;
                    }
                }

                let allType = document.querySelectorAll('.pageCardTitleText');
                allType.forEach(element => {
                    element.classList.remove('active');
                });

                this.type = type;
                if (type == 1 || this.$root.isMob) {
                    let data = await this.$root.getBanner(4);
                    this.banners = data.data;
                    this.imgList = [];
                    data = await this.$root.getCompanyInfo();

                    this.companyList = data.data
                    this.companyList.forEach(item => {
                        if (item.type == 2) {
                            let imgUrl = item.images.split(",");
                            imgUrl = imgUrl.map(pic => this.baseUrl + pic);
                            this.imgList.push(...imgUrl);
                        }
                    });
                    document.getElementById('type1').classList.add('active');
                }
                if (type == 2 || this.$root.isMob) {
                    let data = await this.$root.getCompanyHoner();
                    this.honerList = data.data;

                    document.getElementById('type2').classList.add('active');
                }
                if (type == 3 || this.$root.isMob) {
                    document.getElementById('type3').classList.add('active');
                }
                if (type == 4 || this.$root.isMob) {
                    let data = await this.$root.getJoinUs();
                    this.joinUsList = data.data;
                    this.joinUsList.forEach(item => {
                        let timestamp = item.updatetime;
                        //转换时间戳为YYYY-MM-DD格式
                        let date = new Date(timestamp * 1000).toLocaleDateString();
                        item.date = date;
                    });
                    document.getElementById('type4').classList.add('active');
                }
                this.isBaseDataOK = true;
            },
            fixLightBGHeight(contentElementId, backgroundElementId) {
                if (this.$root.isMob) {
                    this.isIMGOK = true;
                    return
                }

                let pageCard = document.getElementById(contentElementId);
                let lightBG = document.getElementById(backgroundElementId);
                //预调整 以防没有图片
                //let pageCardHeight = pageCard.offsetHeight;    
                // pageCardHeight = pageCardHeight + 200;
                // lightBG.style.height = pageCardHeight + 'px';   
                //判断图片是否全部加载完成
                let imgList = document.querySelectorAll('#pageCard .img img');
                let imgLoadedCount = 0;
                if (imgList.length > 0) {
                    this.$root.loadingOpen();
                    // 添加超时保护3秒
                    let timeout = setTimeout(() => {
                        // console.log('图片加载超时，强制关闭遮盖层');
                        this.isIMGOK = true;
                        this.$root.loadingClose();
                    }, 3000)

                    imgList.forEach((img) => {
                        // 处理缓存情况
                        if (img.complete) {
                            imgLoadedCount++;
                            if (imgLoadedCount == imgList.length) {
                                clearTimeout(timeout);
                                let pageCardHeightAfter = pageCard.offsetHeight;
                                pageCardHeightAfter = pageCardHeightAfter + 200;
                                lightBG.style.height = pageCardHeightAfter + 200 + 'px';
                                this.isIMGOK = true;
                                this.$root.loadingClose();
                            }
                        } else {
                            img.onload = () => {
                                imgLoadedCount++;
                                if (imgLoadedCount === imgList.length) {
                                    let pageCardHeightAfter = pageCard.offsetHeight;
                                    pageCardHeightAfter = pageCardHeightAfter + 200;
                                    lightBG.style.height = pageCardHeightAfter + 200 + 'px';
                                    this.isIMGOK = true;
                                    this.$root.loadingClose();
                                }
                            };
                        }

                    });
                }
                else {
                    let pageCardHeightAfter = pageCard.offsetHeight;
                    pageCardHeightAfter = pageCardHeightAfter + 200;
                    lightBG.style.height = pageCardHeightAfter + 200 + 'px';
                    this.isIMGOK = true;
                }
            },
            turnItems() {
                if (this.$root.isMob) {
                    return
                }
                let items = document.querySelectorAll('.item');
                let length = items.length;
                for (let i = 0; i < length; i++) {
                    if (i % 2 != 0) {
                        items[i].classList.add("itemType2");
                    }
                }
            },
            expandInfo(id) {
                let target = this.$refs["content" + id][0];
                let icon = this.$refs["icon" + id][0];
                if (this.expandList.includes(id)) {
                    //使icon旋转180度
                    icon.style.transform = "rotate(0deg)";
                    target.classList.remove('expContent');
                    this.expandList = this.expandList.filter(item => item !== id);
                }
                else {
                    //使icon旋转0度
                    icon.style.transform = "rotate(180deg)";
                    target.classList.add('expContent');
                    this.expandList.push(id);
                }
                let listen = setInterval(() => {
                    this.fixLightBGHeight("pageCard", "lightBG");
                }, 10);
                setTimeout(() => {
                    clearInterval(listen);
                }, 500);
            },
        },
        created() {
        },
        mounted() {
            this.$nextTick(() => {
                this.getBaseData();
                this.fixLightBGHeight("pageCard", "lightBG");
            });
        },
    }
</script>

<style lang="scss" src="@/assets/css/aboutUsPage.scss" scoped>
</style>